import styled from 'styled-components';
import { remCalc, layout, media } from '@prisjakt/ui-base';

export const ContentColumn = styled.div`
  align-items: flex-start;
  padding: 0 ${layout.pageContent.gutter.rem} 2rem;
  a {
    text-decoration: underline;
  }
`;

export const Logo = styled.img`
  float: right;
  ${media.smallOnly`
    margin: 1rem 0 0;
  `}
  ${media.mediumUp`
    margin: 2rem 0 2rem 2rem;
  `}
`;

export const SectionTitle = styled.h2`
  font-size: ${remCalc(22)};
  font-weight: normal;
  margin-bottom: 0px;
  ${media.smallOnly`
    font-size: ${remCalc(18)};
  `}
`;

export const PersonalizationInterests = styled.div`
  padding-left: ${layout.pageContent.gutter.rem};
`;

export const PersonalizationDescription = styled.div`
  padding-left: ${layout.pageContent.gutter.rem};
`;
